import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import './HeaderIcon.css';
function findLinkSource(link) {
  if (link) {
    if (link.includes('google')) return {
      name: 'google plus',
      style: {
        color: '#DD4B39'
      }
    };
    if (link.includes('facebook')) return {
      name: 'facebook',
      style: {
        color: '#3b5998'
      }
    };
    if (link.includes('yelp')) return {
      name: 'yelp',
      style: {
        color: '#c41200'
      }
    };
    if (link.includes('tripadvisor')) return {
      name: 'tripadvisor',
      style: {
        color: '#00af87'
      }
    };
  }
  return {
    name: '',
    style: {}
  };
}
function renderIcon(iconProps) {
  var name = iconProps.name,
    style = iconProps.style;
  return /*#__PURE__*/React.createElement(Icon, {
    name: name,
    style: style,
    size: "small"
  });
}
var HeaderIcon = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(HeaderIcon, _React$PureComponent);
  var _super = _createSuper(HeaderIcon);
  function HeaderIcon() {
    _classCallCheck(this, HeaderIcon);
    return _super.apply(this, arguments);
  }
  _createClass(HeaderIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        link = _this$props.link,
        showLink = _this$props.showLink,
        isVerticalItem = _this$props.isVerticalItem;
      var iconProps = findLinkSource(link);

      // For verticalItems we need to override the default <Header.Content /> CSS in ItemElement
      if (isVerticalItem) {
        iconProps.style = _objectSpread(_objectSpread({}, iconProps.style), {}, {
          display: 'inline-block',
          fontSize: '1em'
        });
      }
      var icon = renderIcon(iconProps);
      return link && showLink ? /*#__PURE__*/React.createElement("a", {
        href: link,
        target: "_blank",
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "header-icon",
        "aria-label": iconProps.name
      }, icon)) : icon;
    }
  }]);
  return HeaderIcon;
}(React.PureComponent);
export { HeaderIcon as default };
HeaderIcon.defaultProps = {
  showLink: true,
  isVerticalItem: false
};